import analytics from '@/shared-utils/analytics'

import sanitizeSearchQueryForLog from './sanitize-search-query-for-log'

export type LogLtrModelVariantSearchParams = {
  searchQuery: string
  searchQueryLength: number
  rankBy?: string
  requestId: string
}

export default function logLtrModelVariantSearch({
  searchQuery,
  searchQueryLength,
  rankBy,
  requestId,
}: LogLtrModelVariantSearchParams) {
  analytics.log({
    message: 'usb_search_ltr_model_variant_search',
    experimentCode: 'USB_SEARCH_LTR_MODEL',
    searchQuery: sanitizeSearchQueryForLog(searchQuery),
    searchQueryLength,
    rankBy: rankBy ?? null,
    isRelevance: rankBy === 'RELEVANCE',
    requestId,
  })
}
